import { Center, Spinner, Text, VStack } from "@chakra-ui/react"
import React, { useCallback, useState } from "react"
import { AllAlertsQueryVariables, useAllAlertsQuery } from "../../graphql"
import { AlertsList } from "./AlertsList"

export const AllAlerts: React.FC = () => {
	const [pagination, setPagination] = useState<AllAlertsQueryVariables["pagination"]>({ limit: 20, page: 1 })

	const [{ data, fetching, error }] = useAllAlertsQuery({
		variables: { pagination },
	})

	const nextPage = useCallback(() => {
		if (fetching) return

		if (data?.allAlerts.hasNextPage) {
			setPagination((prev) => ({
				...prev,
				page: (prev.page || 0) + 1,
			}))
		}
	}, [data, fetching])

	return (
		<VStack w="full" maxW="2xl" align="stretch">
			{fetching && !data?.allAlerts ? (
				<Center w="full" py="4">
					<VStack w="full" color="grayscale.label">
						<Text fontSize="sm">Loading alerts</Text>
						<Spinner size="sm" />
					</VStack>
				</Center>
			) : error ? (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						{error.message.replace("[GraphQL] ", "")}
					</Text>
				</Center>
			) : data?.allAlerts.alerts && data.allAlerts.alerts.length ? (
				<VStack w="full" align="stretch">
					<Text>
						Showing {data.allAlerts.alerts.length || 0} alert
						{(data.allAlerts.alerts.length || 0) > 1 ? "s" : ""}
					</Text>

					<AlertsList alerts={data.allAlerts.alerts} loadMore={nextPage} />

					{fetching && (
						<Center w="full" py="4">
							<VStack w="full" color="grayscale.label">
								<Text fontSize="sm">Loading more alerts</Text>
								<Spinner size="sm" />
							</VStack>
						</Center>
					)}
				</VStack>
			) : (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						Couldn&apos;t find any alerts.
					</Text>
				</Center>
			)}
		</VStack>
	)
}
